/** @format */

import { post } from "./BaseApi";
import endpoint from "./endpoint";

const handleLoginEmail = async (data) => {
    try {
        let result = await post(endpoint.URL_SIGNING_EMAIL, data);
        return await result.data;
    } catch (err) {
        console.log(err);
    }
};

const handleSignupEmail = async (data) => {
    try {
        let result = await post(endpoint.URL_SINGUP_EMAIL, data);
        return result.data;
    } catch (err) {}
};

const LoginByThirdParty = async (data) => {
    try {
        let result = await post(endpoint.URL_SIGNIN_WITH_FB_GOOGLE, data);
        return result;
    } catch (err) {
        console.log(err);
    }
};

const AccountOperations = {
    handleLoginEmail,
    handleSignupEmail,
	LoginByThirdParty
};

export default AccountOperations;
